var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "security-verification" }, [
    _c("i", {
      staticClass: "back-icon iconfont icon-fanhuianniu",
      class: { mirrorRotateLevel: _vm.isDirection },
      on: {
        click: function($event) {
          return _vm.handleBack()
        }
      }
    }),
    _vm._v(" "),
    _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.$t("300042")))]),
    _vm._v(" "),
    _vm.isGoogle && _vm.type == "email"
      ? _c("div", { staticClass: "tab" }, [
          _c(
            "div",
            {
              staticClass: "pointer tab-item marR32 inline-block bold",
              class: { activeTab: _vm.activeType == "google" },
              on: {
                click: function($event) {
                  return _vm.handleChange("google")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("300331")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pointer tab-item inline-block bold",
              class: { activeTab: _vm.activeType == "email" },
              on: {
                click: function($event) {
                  return _vm.handleChange("email")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("300033")) + "\n    ")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "form" }, [
      _vm.activeType == "google"
        ? _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "block label" }, [
              _vm._v(_vm._s(_vm.$t("300329")))
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.code,
                  expression: "code"
                }
              ],
              attrs: { maxlength: "6" },
              domProps: { value: _vm.code },
              on: {
                blur: _vm.inputBlur,
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.code = $event.target.value
                  },
                  _vm.handleInput
                ]
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "block tip",
                class: _vm.errorTip ? "errorTip" : "normalTip"
              },
              [_vm._v(_vm._s(_vm.tip))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.activeType == "sms"
        ? _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "block label" }, [
              _vm._v(_vm._s(_vm.$t("300052")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "value" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  attrs: { type: "text", maxlength: "6" },
                  domProps: { value: _vm.code },
                  on: {
                    blur: _vm.inputBlur,
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value
                      },
                      _vm.handleInput
                    ]
                  }
                }),
                _vm._v(" "),
                _c("sendCode", {
                  attrs: {
                    isCountDown: _vm.isCountDown,
                    "user-name": _vm.userName,
                    "code-type": _vm.type,
                    "form-type": _vm.formType,
                    interfaceType: _vm.interfaceType,
                    "country-code": _vm.areaCode,
                    validationToken: _vm.validationToken,
                    isGeet: _vm.isGeet,
                    errorFun: _vm.errorFun,
                    successFun: _vm.successFun,
                    countDownFun: _vm.countDownFun
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "block tip",
                class: _vm.errorTip ? "errorTip" : "normalTip"
              },
              [_vm._v(_vm._s(_vm.tip))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.activeType == "email"
        ? _c("div", { staticClass: "form-item" }, [
            _c("span", { staticClass: "block label" }, [
              _vm._v(_vm._s(_vm.$t("300051")))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "value" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.code,
                      expression: "code"
                    }
                  ],
                  attrs: { type: "text", maxlength: "6" },
                  domProps: { value: _vm.code },
                  on: {
                    blur: _vm.inputBlur,
                    input: [
                      function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.code = $event.target.value
                      },
                      _vm.handleInput
                    ]
                  }
                }),
                _vm._v(" "),
                _c("sendCode", {
                  attrs: {
                    isCountDown: _vm.isCountDown,
                    "user-name": _vm.userName,
                    "code-type": _vm.type,
                    "form-type": _vm.formType,
                    interfaceType: _vm.interfaceType,
                    errorFun: _vm.errorFun,
                    successFun: _vm.successFun,
                    validationToken: _vm.validationToken,
                    countDownFun: _vm.countDownFun
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "block tip",
                class: _vm.errorTip ? "errorTip" : "normalTip"
              },
              [_vm._v(_vm._s(_vm.tip))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-item" },
        [
          _c(
            "van-button",
            {
              staticClass: "form-btn",
              class: { disabledBtn: _vm.isDisabled },
              attrs: { disabled: _vm.isDisabled },
              on: { click: _vm.submitCode }
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("300056")) + "\n      ")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9bccdf16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bccdf16","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/verification.vue
// module id = sOy3
// module chunks = 0